/* tslint:disable */
/* eslint-disable */
/**
 * Corrigo API
 * fejlesztői
 *
 * The version of the OpenAPI document: 1.5.2
 * Contact: kerezsigergely@infobex.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
/**
 *
 */
export class OrdersApi extends runtime.BaseAPI {
    /**
     * Rendelés jóváhagyása [ID: ApprovePurchaseOrder]
     */
    approvePurchaseOrderRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['order_id'] == null) {
                throw new runtime.RequiredError('order_id', 'Required parameter "order_id" was null or undefined when calling approvePurchaseOrder().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/orders/{order_id}`.replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters['order_id']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['UpdateOrderRequest'],
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Rendelés jóváhagyása [ID: ApprovePurchaseOrder]
     */
    approvePurchaseOrder(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.approvePurchaseOrderRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     *  [ID: GetOrderStatistics]
     */
    getOrderStatisticsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['organization_id'] != null) {
                queryParameters['organization_id'] = requestParameters['organization_id'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/orders/statistics`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     *  [ID: GetOrderStatistics]
     */
    getOrderStatistics() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.getOrderStatisticsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     *  [ID: GetOrderTimeSeries]
     */
    getOrderTimeSeriesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['isolate'] != null) {
                queryParameters['isolate'] = requestParameters['isolate'];
            }
            if (requestParameters['date_part'] != null) {
                queryParameters['date_part'] = requestParameters['date_part'];
            }
            if (requestParameters['start_date'] != null) {
                queryParameters['start_date'] = requestParameters['start_date'];
            }
            if (requestParameters['end_date'] != null) {
                queryParameters['end_date'] = requestParameters['end_date'];
            }
            if (requestParameters['organization_id'] != null) {
                queryParameters['organization_id'] = requestParameters['organization_id'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/orders/statistics/time_series`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     *  [ID: GetOrderTimeSeries]
     */
    getOrderTimeSeries() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.getOrderTimeSeriesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Rendelés lekérdezése [ID: GetPurchaseOrder]
     */
    getPurchaseOrderRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['order_id'] == null) {
                throw new runtime.RequiredError('order_id', 'Required parameter "order_id" was null or undefined when calling getPurchaseOrder().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/orders/{order_id}`.replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters['order_id']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Rendelés lekérdezése [ID: GetPurchaseOrder]
     */
    getPurchaseOrder(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getPurchaseOrderRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Rendelések lekérdezése [ID: GetPurchaseOrders]
     */
    getPurchaseOrdersRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['organization_id'] != null) {
                queryParameters['organization_id'] = requestParameters['organization_id'];
            }
            if (requestParameters['modified_after'] != null) {
                queryParameters['modified_after'] = requestParameters['modified_after'];
            }
            if (requestParameters['modified_before'] != null) {
                queryParameters['modified_before'] = requestParameters['modified_before'];
            }
            if (requestParameters['submitted_after'] != null) {
                queryParameters['submitted_after'] = requestParameters['submitted_after'];
            }
            if (requestParameters['submitted_before'] != null) {
                queryParameters['submitted_before'] = requestParameters['submitted_before'];
            }
            if (requestParameters['login_id'] != null) {
                queryParameters['login_id'] = requestParameters['login_id'];
            }
            if (requestParameters['plan_id'] != null) {
                queryParameters['plan_id'] = requestParameters['plan_id'];
            }
            if (requestParameters['user_id'] != null) {
                queryParameters['user_id'] = requestParameters['user_id'];
            }
            if (requestParameters['include_logs'] != null) {
                queryParameters['include_logs'] = requestParameters['include_logs'];
            }
            if (requestParameters['status'] != null) {
                queryParameters['status'] = requestParameters['status'];
            }
            if (requestParameters['sort_by'] != null) {
                queryParameters['sort_by'] = requestParameters['sort_by'];
            }
            if (requestParameters['sort_direction'] != null) {
                queryParameters['sort_direction'] = requestParameters['sort_direction'];
            }
            if (requestParameters['limit'] != null) {
                queryParameters['limit'] = requestParameters['limit'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/orders`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Rendelések lekérdezése [ID: GetPurchaseOrders]
     */
    getPurchaseOrders() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.getPurchaseOrdersRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Rendelések lekérdezése login-re [ID: GetPurchaseOrdersForLogin]
     * @deprecated
     */
    getPurchaseOrdersForLoginRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['login_id'] == null) {
                throw new runtime.RequiredError('login_id', 'Required parameter "login_id" was null or undefined when calling getPurchaseOrdersForLogin().');
            }
            const queryParameters = {};
            if (requestParameters['CREATED'] != null) {
                queryParameters['CREATED'] = requestParameters['CREATED'];
            }
            if (requestParameters['CANCELLED'] != null) {
                queryParameters['CANCELLED'] = requestParameters['CANCELLED'];
            }
            if (requestParameters['REJECTED'] != null) {
                queryParameters['REJECTED'] = requestParameters['REJECTED'];
            }
            if (requestParameters['APPROVED'] != null) {
                queryParameters['APPROVED'] = requestParameters['APPROVED'];
            }
            if (requestParameters['PROCESSING'] != null) {
                queryParameters['PROCESSING'] = requestParameters['PROCESSING'];
            }
            if (requestParameters['ERRORED'] != null) {
                queryParameters['ERRORED'] = requestParameters['ERRORED'];
            }
            if (requestParameters['FULFILLED'] != null) {
                queryParameters['FULFILLED'] = requestParameters['FULFILLED'];
            }
            if (requestParameters['DELETED'] != null) {
                queryParameters['DELETED'] = requestParameters['DELETED'];
            }
            if (requestParameters['organization_id'] != null) {
                queryParameters['organization_id'] = requestParameters['organization_id'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/logins/{login_id}/orders`.replace(`{${"login_id"}}`, encodeURIComponent(String(requestParameters['login_id']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Rendelések lekérdezése login-re [ID: GetPurchaseOrdersForLogin]
     * @deprecated
     */
    getPurchaseOrdersForLogin(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getPurchaseOrdersForLoginRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Előfizetési csomagok lekérdezése [ID: GetSubscriptionPlans]
     */
    getSubscriptionPlansRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['organization_id'] != null) {
                queryParameters['organization_id'] = requestParameters['organization_id'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/orders/plans`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Előfizetési csomagok lekérdezése [ID: GetSubscriptionPlans]
     */
    getSubscriptionPlans() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.getSubscriptionPlansRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Rendelés leadása [ID: SubmitPurchaseRequest]
     */
    submitPurchaseRequestRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['SubmitPurchaseRequestRequest'] == null) {
                throw new runtime.RequiredError('SubmitPurchaseRequestRequest', 'Required parameter "SubmitPurchaseRequestRequest" was null or undefined when calling submitPurchaseRequest().');
            }
            const queryParameters = {};
            if (requestParameters['dry_run'] != null) {
                queryParameters['dry_run'] = requestParameters['dry_run'];
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/orders`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['SubmitPurchaseRequestRequest'],
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Rendelés leadása [ID: SubmitPurchaseRequest]
     */
    submitPurchaseRequest(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.submitPurchaseRequestRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Rendelés törlése [ID: TerminatePurchaseOrder]
     */
    terminatePurchaseOrderRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['order_id'] == null) {
                throw new runtime.RequiredError('order_id', 'Required parameter "order_id" was null or undefined when calling terminatePurchaseOrder().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/orders/{order_id}`.replace(`{${"order_id"}}`, encodeURIComponent(String(requestParameters['order_id']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['UpdateOrderRequest'],
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Rendelés törlése [ID: TerminatePurchaseOrder]
     */
    terminatePurchaseOrder(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.terminatePurchaseOrderRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Rendelési igény validálása [ID: ValidatePurchaseRequest]
     * @deprecated
     */
    validatePurchaseRequestRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/orders/validate`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['PurchaseRequest'],
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Rendelési igény validálása [ID: ValidatePurchaseRequest]
     * @deprecated
     */
    validatePurchaseRequest() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.validatePurchaseRequestRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
/**
 * @export
 */
export const GetOrderTimeSeriesDatePartEnum = {
    hour: 'hour',
    day: 'day',
    week: 'week',
    month: 'month'
};
/**
 * @export
 */
export const GetPurchaseOrdersSortByEnum = {
    submitted: 'submitted',
    modified: 'modified',
    due: 'due'
};
